module.exports = __webpack_public_path__ + "static/img/PeasonalizedTarget-background.b0668b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/PeasonalizedTarget-background.png
// module id = 9gz/
// module chunks = 1